import {
  getReportHistory as getHistoryAPI,
  getFavoriteReports as getFavoritesAPI,
  getReportById as getByIdAPI,
  deleteReport as deleteReportAPI,
  toggleFavorite as toggleFavoriteAPI
} from './agentcore.service';

/**
 * Service for managing report history and favorites
 * Calls Lambda database service via agentcore.service
 */

/**
 * Get report history
 */
export const getReportHistory = async () => {
  return await getHistoryAPI();
};

/**
 * Get favorite reports
 */
export const getFavoriteReports = async () => {
  return await getFavoritesAPI();
};

/**
 * Get a specific report by ID
 */
export const getReportById = async (reportId) => {
  return await getByIdAPI(reportId);
};

/**
 * Delete a report
 */
export const deleteReport = async (reportId) => {
  return await deleteReportAPI(reportId);
};

/**
 * Toggle favorite status of a report
 */
export const toggleReportFavorite = async (reportId, isFavorite) => {
  try {
    const response = await toggleFavoriteAPI(reportId, isFavorite);
    return response;
  } catch (error) {
    console.error('[toggleReportFavorite] Error:', error);
    throw error;
  }
};
